export default __webpack_public_path__ + "static/media/h2-2.d834d21e.jpg";